// extracted by mini-css-extract-plugin
module.exports = {"swiper-box":"swiper_swiper-box__e_MHm","banner-item":"swiper_banner-item__ovF8R","banner-item-bg":"swiper_banner-item-bg__iBhb9"};